/**
 * @generated SignedSource<<a43730511a8959c6d77883b50354f053>>
 * @relayHash c5d06069aa243f9c17a1556d0a233a1a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/580.0.0-2026-10-07T07:45:34.900Z/useAddItemToCart_userCartItemAddMutation

import { ConcreteRequest } from 'relay-runtime';
export type CartType = "CHECKOUT" | "SAVE_FOR_LATER" | "%future added value";
export type UserCartItemAddOrUpdateInput = {
  buyerId?: number | null;
  clientMutationId?: string | null;
  itemId: string;
  quantity: number;
  skuId: string;
  type: CartType;
};
export type useAddItemToCart_userCartItemAddMutation$variables = {
  input: UserCartItemAddOrUpdateInput;
  monitoringGroupName: string;
};
export type useAddItemToCart_userCartItemAddMutation$data = {
  readonly userCartItemAddOrUpdate: {
    readonly cartItem: {
      readonly serviceId: string | null;
      readonly skuId: string | null;
    } | null;
  } | null;
};
export type useAddItemToCart_userCartItemAddMutation = {
  response: useAddItemToCart_userCartItemAddMutation$data;
  variables: useAddItemToCart_userCartItemAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "monitoringGroupName"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddItemToCart_userCartItemAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UserCartItemAddOrUpdatePayload",
        "kind": "LinkedField",
        "name": "userCartItemAddOrUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CartItem",
            "kind": "LinkedField",
            "name": "cartItem",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useAddItemToCart_userCartItemAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UserCartItemAddOrUpdatePayload",
        "kind": "LinkedField",
        "name": "userCartItemAddOrUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CartItem",
            "kind": "LinkedField",
            "name": "cartItem",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/580.0.0-2026-10-07T07:45:34.900Z/useAddItemToCart_userCartItemAddMutation",
    "metadata": {},
    "name": "useAddItemToCart_userCartItemAddMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "fce05f30d1f502805a8777fdeb6c12c0";

export default node;
